import { type AsyncState, Status } from '@essent/common';
import type { PostAdviceV1Response } from '@integration/api-client/feh';
import { createReducer, on } from '@ngrx/store';
import type { ScLinkField } from '@core/jss-models';
import { FehApiActions } from '@feh/shared-api';

import {
  resetSubmitState,
  setRedirectUrl,
} from '../actions/general-advice-form.actions';

export const generalAdviceFormSelectorKey = 'general-advice-form';

export type GeneralAdviceFormSubmitState = AsyncState<PostAdviceV1Response>;

export interface GeneralAdviceFormState {
  submitState: GeneralAdviceFormSubmitState;
  redirectUrl: ScLinkField | null;
}

export const initialGeneralAdviceFormState: GeneralAdviceFormState = {
  submitState: { status: Status.IDLE },
  redirectUrl: null,
};

/**
 * Only update when actionId belongs to homebattery advice form
 */
function updateOrIgnore<T>(actionId: unknown, oldState: T, newState: T): T {
  return actionId === generalAdviceFormSelectorKey ? newState : oldState;
}

const apiActions = FehApiActions.postAdviceV1;

export const generalAdviceFormReducer = createReducer(
  initialGeneralAdviceFormState,
  on(apiActions.requestAction, (state, { actionId }) =>
    updateOrIgnore(actionId, state, {
      ...state,
      submitState: { status: Status.PENDING },
    })
  ),
  on(apiActions.errorAction, (state, { actionId, payload }) =>
    updateOrIgnore(actionId, state, {
      ...state,
      submitState: { status: Status.ERROR, error: payload },
    })
  ),
  on(setRedirectUrl, (state, { redirectUrl }) => {
    return {
      ...state,
      redirectUrl,
    };
  }),
  on(resetSubmitState, (state) => {
    return {
      ...state,
      submitState: initialGeneralAdviceFormState.submitState,
    };
  })
);
